import { Lesson } from "@jelly/lesson";

import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import principle01 from "./layouts/principle-01/principle";

const lesson: Lesson = {
  id: "643e95a8-7f52-4350-bd1b-b7be63800b71",
  publicId: "12",
  name: "Snell-Descartes laws",
  difficulty: 2,
  contentTypes: { audio: false, interactive: false, video: true },
  body: [principle01, task01, task02],
};

export default lesson;
